import { langStore } from "@/stores/lang-store"
import { formatMessage } from "@/utils/format-message"
import { householdListBundle } from "./household-const"
import Wrapper from "@/components/wrapper"

const HouseholdSelector = ({ households, active, onClick, indicator, className = "" }) => {
  const { lang } = langStore()

  return (
    <Wrapper.shadow className={className}>
      <div className="flex flex-col gap-1 w-full h-full min-w-50 overflow-y-auto pr-1 custom-scrollbar">
        {households.length > 0 ? (
          households.map((household) => {
            const key = `${household.dong}-${household.ho}`
            const isActive = active === key

            return (
              <div
                key={key}
                onClick={() => onClick(household)}
                className={`
                  group relative flex items-center justify-between px-4 py-3 
                  rounded-xl transition-all duration-200 cursor-pointer
                  ${isActive ? "bg-blue-50/80 shadow-sm" : "hover:bg-gray-50"}
                `}
              >
                {/* Active 시 좌측 포인트 바 */}
                {isActive && (
                  <div className="absolute left-0 top-1/4 bottom-1/4 w-1 bg-blue-500 rounded-r-full" />
                )}

                <div className="flex flex-col">
                  <span className={`font-bold ${isActive ? "text-blue-700" : "text-gray-700"}`}>
                    {formatMessage(householdListBundle.unitAddress[lang], {
                      dong: +household.dong,
                      ho: +household.ho
                    })}
                  </span>
                  <span className="text-xs text-gray-400 mt-0.5">
                    {indicator.label[lang]}:{" "}
                    <span className="font-medium text-gray-600">
                      {household[indicator.key].toFixed(2)}
                      {indicator.unit}
                    </span>
                  </span>
                </div>

                <div className="flex items-center gap-2">
                  <span
                    className={`text-xl transition-transform duration-200 ${isActive ? "translate-x-1 text-blue-500" : "text-gray-300 group-hover:translate-x-1"}`}
                  >
                    ›
                  </span>
                </div>
              </div>
            )
          })
        ) : (
          <div className="py-10 text-center text-gray-400 text-sm">
            {householdListBundle.emptyMessage[lang]}
          </div>
        )}
      </div>
    </Wrapper.shadow>
  )
}

export default HouseholdSelector
